window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('input[type="checkbox"]').length) {
    import('./_form-required-checkbox-validation.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
